import {TranslatableProductQueryData} from '../../graphql/TranslatableProductQuery.graphql';
import {TranslatableResourceInformation} from '../../types';

import {Metafield} from './types';

const MAX_INPUT_SIZE = 100;

export function getMetafieldResourceInfo(
  metafields: Metafield[],
): TranslatableResourceInformation[] {
  return metafields.map(
    ({id, definition, type, ownerType, namespace, key}) => ({
      resourceId: id,
      overrides: {
        type,
        ownerType,
        namespace,
        key,
        validations: definition?.validations?.map(({value}) => value) ?? [],
        name: definition?.name ?? `${namespace}.${key}`,
      },
    }),
  );
}

export function getOptionsResourceInfo(
  productOptions: TranslatableProductQueryData.ProductOptions[],
): TranslatableResourceInformation[] {
  return productOptions.map(({id, position}) => ({
    resourceId: id,
    overrides: {
      position,
    },
  }));
}

export function getOptionValuesResourceInfo(
  productOptions: TranslatableProductQueryData.ProductOptions[],
): TranslatableResourceInformation[] {
  return productOptions.flatMap((option) =>
    option.optionValues.map((value) => ({
      resourceId: value.id,
      overrides: {position: option.position},
    })),
  );
}

export function getVariantsResourceInfo(
  productVariants: TranslatableProductQueryData.ProductVariants[],
): {
  variantsMetafieldsInfo: TranslatableResourceInformation[];
} {
  const variantsMetafieldsInfo: TranslatableResourceInformation[] = [];
  productVariants.forEach(({metafields}) => {
    if (metafields.length > 0) {
      variantsMetafieldsInfo.push(
        ...getMetafieldResourceInfo(metafields as Metafield[]),
      );
    }
  });

  return {
    variantsMetafieldsInfo,
  };
}

export function splitTranslatableResourceIds(
  resource_ids: string[],
  after_id?: string,
  before_id?: string,
): string[] {
  const index = resource_ids.indexOf(after_id || before_id || '');

  if (index !== -1) {
    if (after_id)
      return resource_ids.slice(index + 1, index + 1 + MAX_INPUT_SIZE);
    if (before_id) return resource_ids.slice(index - MAX_INPUT_SIZE, index);
  }

  return resource_ids.slice(0, MAX_INPUT_SIZE);
}
